import React from 'react';
import { useTranslation } from 'react-i18next';
import { introSection } from '../utils/introContent';
import { introSectionEn } from '../utils/introContentEn';
import { getRelatedSectionsForMuseo } from '../utils/relatedSections';
import RelatedSections from './RelatedSections';

const Introduccion = () => {
    const { t, i18n } = useTranslation();
    const content = i18n.language === 'en' ? introSectionEn : introSection;

    return (
        <div className='TesisPage TesisPage--museo'>
            <aside className='TesisPage-rail'>
                <RelatedSections items={getRelatedSectionsForMuseo('/Introduccion')} />
            </aside>
            <h1 className='TesisPageTitle'>{t('introduccion.title')}</h1>
            {t('introduccion.subtitle') && <h2 className='TesisPageSubtitle'>{t('introduccion.subtitle')}</h2>}
            <article className='TesisPageContent'>
                {content.map((p, i) => <p key={i}>{p}</p>)}
            </article>
        </div>
    );
};

export default Introduccion;
